























































import {Component, Prop, Vue} from "vue-property-decorator";
import {ILayoutItem, resolveSelectOptions} from "@/components/CustomForm/common";
import {AttachmentHostType, CustomFormFieldCreateOrUpdateDto, CustomFormType, SelectListItem} from "@/api/appService";
import UploadedFilesView from "@/components/CustomForm/FormDetail/components/UploadedFilesView.vue";
import ProvinceCityAreaView from "@/components/CustomForm/FormDetail/components/ProvinceCityAreaView.vue";
import RadioView from "@/components/CustomForm/FormDetail/components/RadioView.vue";

@Component({
  name: 'FormRowItem',
  components: {RadioView, ProvinceCityAreaView, UploadedFilesView},
  filters:{
    elementType(formControl:CustomFormFieldCreateOrUpdateDto | undefined){
      return (formControl?.elementType || 'NONE')
    }
  }
})
export default class FormRowItem extends Vue {

  @Prop({required: true})
  item!: ILayoutItem;


  @Prop({required: true})
  items!: ILayoutItem[];

  @Prop({required: true})
  data!: any;


  @Prop({required: true})
  hostType!: CustomFormType;

  debugMode = false






  getValue(control: CustomFormFieldCreateOrUpdateDto) {
    let fieldName = '';
    if (control.isDynamic) {
      fieldName = control.fieldName!;
    } else {
      fieldName = control.fieldName!.substr(0, 1).toLowerCase() + control.fieldName!.substr(1);
    }

    if (this.data.hasOwnProperty(fieldName)) {
      return this.data[fieldName] ?? '';
    } else if (this.data.hasOwnProperty('extensionObject') && this.data.extensionObject.hasOwnProperty(fieldName)) {
      return this.data.extensionObject[fieldName] ?? '';
    } else {
      return '';
    }
  }

  getTitleAlignClass(textAlign: string | undefined) {
    if (!textAlign) {
      return 'text-aline-left text-align-left'
    } else {
      return 'text-aline-' + textAlign + ' text-align-' + textAlign
    }
  }

  get uploadHostType() {
    switch (this.hostType) {
      case CustomFormType.InternalProject:
        return AttachmentHostType.Internal_Project;
      case CustomFormType.Beneficiary:
        return AttachmentHostType.Beneficiary;
      case CustomFormType.SchoolServiceRecord:
        return AttachmentHostType.Internal_ServiceRecord;
      case CustomFormType.BeneficiaryServiceRecord:
        return AttachmentHostType.Internal_ServiceRecord;
      case CustomFormType.OrganizationUnit:
        return AttachmentHostType.OrganizationUnit;
      case CustomFormType.Volunteer:
        return AttachmentHostType.Volunteer;
    }
  }

  //判断图片
  isSimpleUploadImage(value: string) {
    return (['simple-upload-image', 'upload-simple-image', 'simpleUploadImage', 'uploadSimpleImage'].some(name => name === value));
  }


  //判断开关
  isSwitch(value: string) {
    return (['el-switch', 'switch', 'Switch']).some(name => name === value);
  }


  // 获取附件hostId
  getHostId(formItemId: string) {
    return this.data.id + ':' + formItemId
  }



}
